__turbopack_context__.v({
  "imageFooter": "public-vote-module-scss-module__zDphca__imageFooter",
  "logo": "public-vote-module-scss-module__zDphca__logo",
  "responsiveButton": "public-vote-module-scss-module__zDphca__responsiveButton",
  "votingBox": "public-vote-module-scss-module__zDphca__votingBox",
});
